<template>
  <div>
    <v-row
      no-gutters
      v-if="isLoading"
      justify="center"
      align="center"
      class="fill-height"
    >
      <v-col cols="1">
        <v-progress-circular
          indeterminate
          size="50"
          width="5"
          :class="progressClass"
          color="light-blue"
        ></v-progress-circular>
      </v-col>
    </v-row>
    <div class="error text-center" v-else-if="isEmpty">
      {{ generateMessage(`${i18nPath}.noItems`) }}
    </div>
    <slot v-else />
  </div>
</template>
<script>
import { generateMessage } from '@/utils/i18n';

export default {
  name: 'Loader',
  methods: {
    generateMessage,
  },
  props: {
    isEmpty: { type: Boolean, default: false },
    isLoading: { type: Boolean, required: true },
    i18nPath: { type: String, required: false },
    progressClass: { type: String, required: false },
  },
};
</script>
